import React from 'react';
import './Header2.css';
import logo_sarsindialiaison from '../../assets/images/logo_sarsindialiaison.jpg';

export default function Header2() {
  return (
    <header className="navbar">
      <div className="navbar-logo">
        <img src={logo_sarsindialiaison} alt="Company Logo" className="logo" />
      </div>
      <nav className="navbar-nav">
        <ul className="nav-list">
          <li><a href="/">Home</a></li>
          <li><a href="/about">About</a></li>
          <li className="dropdown">
            <a href="/services" className="dropdown-link">Services</a>
            <ul className="dropdown-menu">
              {/* Engineering Section */}
              <li className="dropdown-item">
                <a href="/services/engineering">Engineering</a>
                <ul className="sub-dropdown">
                  <li><a href="/services/engineering/peso-architectural-design">PESO-Architectural Designing for Storage Tank</a></li>
                  <li><a href="/services/engineering/plan-approval">Plan Approval</a></li>
                </ul>
              </li>
              {/* Licensing Section */}
              <li className="dropdown-item">
                <a href="/services/licensing">Licensing</a>
                <ul className="sub-dropdown">
                  <li><a href="/services/licensing/peso-licensing">PESO Licensing</a></li>
                  <li><a href="/services/licensing/factory-licensing">Factory Licensing</a></li>
                  <li><a href="/services/licensing/environmental-clearance">Environmental Clearance</a></li>
                  <li><a href="/services/licensing/forest-clearance">Forest Clearance</a></li>
                  <li><a href="/services/licensing/cgwa-noc">CGWA-NOC</a></li>
                  <li><a href="/services/licensing/regulatory-compliances">Regulatory Compliances</a></li>
                  <li><a href="/services/licensing/explosives-licensing">Explosives Licensing</a></li>
                  <li><a href="/services/licensing/clinical-establishment-licensing">Clinical Establishment Licensing</a></li>
                  <li><a href="/services/licensing/pollution-control-licensing">Pollution Control Licensing</a></li>
                </ul>
              </li>
              {/* NOCs/Approvals/Permits */}
              <li className="dropdown-item">
                <a href="/services/nocs">NOCs/Approvals/Permits</a>
                <ul className="sub-dropdown">
                  <li><a href="/services/nocs/dummy-category-1">Dummy Category 1</a></li>
                  <li><a href="/services/nocs/dummy-category-2">Dummy Category 2</a></li>
                </ul>
              </li>
              {/* Miscellaneous Services */}
              <li className="dropdown-item">
                <a href="/services/miscellaneous">Miscellaneous Services</a>
                <ul className="sub-dropdown">
                  <li><a href="/services/miscellaneous/training">Professional Training</a></li>
                  <li><a href="/services/miscellaneous/consultancy">Technical Consultancy</a></li>
                </ul>
              </li>
              {/* Others */}
              <li className="dropdown-item">
                <a href="/services/others">Others</a>
                <ul className="sub-dropdown">
                  <li><a href="/services/others/feasibility-study">Feasibility Study for Construction</a></li>
                  <li><a href="/services/others/eia-study">Environmental Impact Assessment (EIA) Study Report</a></li>
                  <li><a href="/services/others/competent-person-services">Competent Person Services for PESO</a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li><a href="/testimonials">Testimonials</a></li>
          <li><a href="/contact-us">Contact Us</a></li>
        </ul>
      </nav>
      <div className="navbar-search">
        <input type="text" placeholder="Search..." />
      </div>
    </header>
  );
}
